import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { GridRow, Column, MoneyField } from '../../common';

const FECSection6b = ({ q6bColA, q6bColB }) => {
  return (
    <Fragment>
      <GridRow>
        <Column md={4} classNames="sub-question">
          <p>
            (b) Total Contribution Refunds
            <br />
            {'from Line 20(d))'}
          </p>
        </Column>
        <Column md={4} classNames="entry-row">
          <MoneyField
            disabled
            value={q6bColA || 0}
          />
        </Column>
        <Column md={4} classNames="entry-row">
          <MoneyField disabled value={q6bColB || 0} />
        </Column>
      </GridRow>
    </Fragment>
  );
};

FECSection6b.propTypes = {
  q6bColA: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  q6bColB: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FECSection6b;
